import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';

import InviteToViewDocsForm from './invite_to_view_docs_form';
import { inviteToViewDocs } from '../../../../actions/leads';

const INVITE_TO_VIEW_DOCS_BTN_LABEL = 'Invite to View Docs';
const REINVITE_TO_VIEW_DOCS_BTN_LABEL = 'Resend Invite to View Docs';

export function InviteToViewDocsLink({ lead, saleOrLease, inviteToViewDocs }) {
  const [openConfirmInviteModal, setOpenConfirmInviteModal] = useState(false);

  const handleInviteLinkClick = (e) => {
    e.preventDefault();
    setOpenConfirmInviteModal(true);
  };

  const handleInviteToViewDocs = ({ caFile, role }) => {
    return inviteToViewDocs(lead, { caFile, role, saleOrLease });
  };

  const pendingInvite = () => {
    return saleOrLease.toLowerCase() == 'sale' ? lead.pendingSaleInviteData : lead.pendingLeaseInviteData;
  };

  return (
    <React.Fragment>
      <span className="border-left pl-3 ml-3">
        <a className="clickable" name="invite-link" onClick={handleInviteLinkClick}>
          {pendingInvite() ? REINVITE_TO_VIEW_DOCS_BTN_LABEL : INVITE_TO_VIEW_DOCS_BTN_LABEL}
        </a>
      </span>
      <Modal className="overflow-visible" show={openConfirmInviteModal} onHide={() => setOpenConfirmInviteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {pendingInvite() ? REINVITE_TO_VIEW_DOCS_BTN_LABEL : INVITE_TO_VIEW_DOCS_BTN_LABEL}
          </Modal.Title>
        </Modal.Header>
        <InviteToViewDocsForm
          pendingInvite={pendingInvite()}
          saleOrLease={saleOrLease}
          onClose={() => setOpenConfirmInviteModal(false)}
          onSubmit={handleInviteToViewDocs}
        />
      </Modal>
    </React.Fragment>
  );
}

InviteToViewDocsLink.propTypes = {
  inviteToViewDocs: PropTypes.func.isRequired,
  lead: PropTypes.shape({
    id: PropTypes.number.isRequired,
    pendingSaleInviteData: PropTypes.object,
    pendingLeaseInviteData: PropTypes.object
  }).isRequired,
  saleOrLease: PropTypes.string.isRequired,
};

const actions = {
  inviteToViewDocs
};

export default connect(null, actions)(InviteToViewDocsLink);
